import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText, renderPageTemplate } from "../../../utils";

export default {
    title: "MyTrumpf/Page Templates/Homepage",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        infoBanner: true,
        shopsAvailable: 3,
        guidedTour: true,
        autoStart: true,
    },
    argTypes: {
        infoBanner: {
            control: "boolean",
        },
        shopsAvailable: {
            options: [1, 2, 3],
            control: { type: "radio" },
        },
        guidedTour: {
            control: "boolean",
        },
        autoStart: {
            control: "boolean",
        },
    },
};

const TemplateRedesign = (args) => {
    return html`
        <div class="ux-t-container-full">
            <div class="ux-row">
                <div class="ux-col-12">
                    ${args.infoBanner
                        ? html`<ux-info-banner icon="circle-info" type="info">
                              <p>
                                  Updates on the platform: Lorem ipsum kmflkw
                                  gkejgoerno.
                                  <a href="#" class="ux-text-tiny--bold">
                                      Mehr erfahren</a
                                  >
                              </p>
                          </ux-info-banner>`
                        : ""}
                </div>
            </div>
        </div>
        <div class="ux-t-container-full">
            <div class="ux-row">
                <div class="ux-col-12">
                    <div
                        class="ux-iws-hero-header-text ux-u-pt-fluid-xxs ux-u-pb-fluid-xxs"
                    >
                        <div class="ux-row">
                            <div class="ux-col-10 ux-u-offset-1">
                                <h1
                                    class="ux-iws-hero-header-text-inner ux-text-headline ux-text-headline--vast ux-u-mb-md-m"
                                >
                                    Welcome to MyTRUMPF
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ux-t-container-full ux-u-d-md-none">
            <div class="ux-row">
                <div class="ux-col-12">${RedesignedQuickLinksMobile()}</div>
            </div>
        </div>
        <div class="ux-t-container ux-u-d-none ux-u-d-md-block ux-u-mt-nm">
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-sm-6 ux-col-md-4 ux-col-xl-2 ux-u-mb-xs ux-u-mb-xl-zero"
                >
                    <ux-iws-teaser-icon
                        icon-name="machine"
                        icon-size="75"
                        shadow="true"
                        variant="service-icon"
                        class="ux-u-h-100 ux-u-d-flex ux-u-flex-ai-center ux-u-flex-jc-center"
                    >
                        <span
                            slot="title"
                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                            data-same-height="title"
                        >
                            Meine Maschinen
                        </span>
                        <a slot="link" href="#my-machines"> </a>
                    </ux-iws-teaser-icon>
                </div>
                <div
                    class="ux-col-12 ux-col-sm-6 ux-col-md-4 ux-col-xl-2 ux-u-mb-xs ux-u-mb-xl-zero"
                >
                    <ux-iws-teaser-icon
                        icon-name="newspaper"
                        icon-size="75"
                        shadow="true"
                        variant="service-icon"
                        class="ux-u-h-100 ux-u-d-flex ux-u-flex-ai-center ux-u-flex-jc-center"
                    >
                        <span
                            slot="title"
                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                            data-same-height="title"
                        >
                            Meine Bestellungen
                        </span>
                        <a slot="link" href="#my-machines"> </a>
                    </ux-iws-teaser-icon>
                </div>
                <div
                    class="ux-col-12 ux-col-sm-6 ux-col-md-4 ux-col-xl-2 ux-u-mb-xs ux-u-mb-xl-zero"
                >
                    <ux-iws-teaser-icon
                        icon-name="hand-list-arrow"
                        icon-size="75"
                        shadow="true"
                        variant="service-icon"
                        class="ux-u-h-100 ux-u-d-flex ux-u-flex-ai-center ux-u-flex-jc-center"
                    >
                        <span
                            slot="title"
                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                            data-same-height="title"
                        >
                            Meine Servicefälle
                        </span>
                        <a slot="link" href="#my-machines"> </a>
                    </ux-iws-teaser-icon>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-col-md-4 ux-col-xl-2 ">
                    <ux-iws-teaser-icon
                        icon-name="software-cube"
                        icon-size="75"
                        shadow="true"
                        variant="service-icon"
                        class="ux-u-h-100 ux-u-d-flex ux-u-flex-ai-center ux-u-flex-jc-center"
                    >
                        <span
                            slot="title"
                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                            data-same-height="title"
                        >
                            Meine Software
                        </span>
                        <a slot="link" href="#my-machines"> </a>
                    </ux-iws-teaser-icon>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-col-md-4 ux-col-xl-2 ">
                    <ux-iws-teaser-icon
                        icon-name="arrow-download"
                        icon-size="75"
                        shadow="true"
                        variant="service-icon"
                        class="ux-u-h-100 ux-u-d-flex ux-u-flex-ai-center ux-u-flex-jc-center"
                    >
                        <span
                            slot="title"
                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                            data-same-height="title"
                        >
                            Downloads
                        </span>
                        <a slot="link" href="#my-machines"> </a>
                    </ux-iws-teaser-icon>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-col-md-4 ux-col-xl-2 ">
                    <ux-iws-teaser-icon
                        icon-name="whiteboard-avatar"
                        icon-size="75"
                        shadow="true"
                        variant="service-icon"
                        class="ux-u-h-100 ux-u-d-flex ux-u-flex-ai-center ux-u-flex-jc-center"
                    >
                        <span
                            slot="title"
                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                            data-same-height="title"
                        >
                            Schulungen
                        </span>
                        <a slot="link" href="#my-machines"> </a>
                    </ux-iws-teaser-icon>
                </div>
            </div>
        </div>
        <div class="ux-t-container ux-u-mt-fluid-m ux-u-mb-fluid-l">
            <div class="ux-row">
                ${args.shopsAvailable === 3
                    ? html`
                          <div class="ux-col-12 ux-col-md-4 ux-u-mb-xs">
                              ${originalPartsTile()}
                          </div>
                          <div class="ux-col-12 ux-col-md-4 ux-u-mb-xs">
                              ${punchingToolsTile()}
                          </div>
                          <div class="ux-col-12 ux-col-md-4 ux-u-mb-xs">
                              ${bendingToolsTile()}
                          </div>
                          <div class="ux-col-12">
                              ${explosionDrawingTile(
                                  "ux-iws-teaser-tile--low",
                                  "ux-iws-teaser-tile--center",
                                  args.shopsAvailable
                              )}
                          </div>
                      `
                    : args.shopsAvailable === 2
                    ? html` <div class="ux-col-12 ux-col-md-4 ux-u-mb-xs">
                              ${originalPartsTile()}
                          </div>
                          <div class="ux-col-12 ux-col-md-4 ux-u-mb-xs">
                              ${punchingToolsTile()}
                          </div>
                          <div class="ux-col-12 ux-col-md-4 ux-u-mb-xs">
                              ${explosionDrawingTile(
                                  "",
                                  "",
                                  args.shopsAvailable
                              )}
                          </div>`
                    : args.shopsAvailable === 1
                    ? html`<div class="ux-col-12 ux-col-md-6 ux-u-mb-xs">
                              ${originalPartsTile()}
                          </div>
                          <div class="ux-col-12 ux-col-md-6 ux-u-mb-xs">
                              ${explosionDrawingTile(
                                  "",
                                  "",
                                  args.shopsAvailable
                              )}
                          </div>`
                    : ""}
            </div>
        </div>
        <div
            class="ux-t-container-full ux-u-background-grey ux-u-pt-fluid-xs ux-u-pb-fluid-xs"
        >
            <div class="ux-row">
                <div class="ux-col-12">
                    <ux-slider
                        container-width-s="83.33%"
                        container-width-m="83.33%"
                        container-width-l="83.33%"
                        container-width-xl="83.33%"
                        visible-slides-s="1"
                        visible-slides-m="1"
                        visible-slides-l="1.3"
                        visible-slides-xl="1.6"
                        space-between-s="30"
                        space-between-m="30"
                        space-between-l="30"
                        space-between-xl="30"
                        breakpoint-s="768"
                        breakpoint-m="1024"
                        breakpoint-l="1440"
                        arrows-follow-img=""
                        slides-auto-height=""
                        slides-overflow-visible=""
                    >
                        <ux-slider-slide>
                            <ux-iws-link-wrapper
                                class="ux-iws-teaser-story ux-iws-teaser-story--horizontal"
                            >
                                <div
                                    class="ux-iws-teaser-story__image-container"
                                >
                                    <img
                                        src="./mock-assets/images/mytrumpf/myt-homepage-slider-image-1.png"
                                        alt=""
                                    />
                                </div>
                                <div class="ux-iws-teaser-story__tag-container">
                                    <div
                                        class="ux-iws-teaser-story__tag ux-iws-teaser-story__tag--green"
                                    >
                                        EVENT
                                    </div>
                                </div>
                                <div class="ux-iws-teaser-story__content">
                                    <div class="ux-iws-teaser-story__info">
                                        <h4
                                            class="ux-text-headline--small ux-u-mx-zero"
                                        >
                                            Name of the event
                                        </h4>
                                        <span
                                            class="ux-text-tiny ux-text-tiny--bold ux-u-mx-zero"
                                        >
                                            29. Oktober bis 03. November 2022
                                        </span>
                                        <ux-text-lines-limit
                                            text-lines-l="5"
                                            text-lines-xl="5"
                                        >
                                            <p>${getDummyText(410)}</p>
                                        </ux-text-lines-limit>
                                    </div>
                                    <div class="ux-iws-teaser-story__cta">
                                        <a
                                            href="#"
                                            class="ux-button ux-button--icon-only"
                                            title="next"
                                            aria-label="Next"
                                            role="button"
                                        >
                                            <ux-icon name="chevron-right" />
                                        </a>
                                    </div>
                                </div>
                            </ux-iws-link-wrapper>
                        </ux-slider-slide>
                        <ux-slider-slide>
                            <ux-iws-link-wrapper
                                class="ux-iws-teaser-story ux-iws-teaser-story--horizontal"
                            >
                                <div
                                    class="ux-iws-teaser-story__image-container"
                                >
                                    <img
                                        src="./mock-assets/images/mytrumpf/myt-homepage-slider-image-1.png"
                                        alt=""
                                    />
                                </div>
                                <div class="ux-iws-teaser-story__tag-container">
                                    <div class="ux-iws-teaser-story__tag">
                                        NEWS
                                    </div>
                                </div>
                                <div class="ux-iws-teaser-story__content">
                                    <div class="ux-iws-teaser-story__info">
                                        <h4
                                            class="ux-text-headline--small ux-u-mx-zero"
                                        >
                                            Name of the event
                                        </h4>
                                        <span
                                            class="ux-text-tiny ux-text-tiny--bold ux-u-mx-zero"
                                        >
                                            29. Oktober bis 03. November 2022
                                        </span>
                                        <ux-text-lines-limit
                                            text-lines-l="5"
                                            text-lines-xl="5"
                                        >
                                            <p>${getDummyText(500)}</p>
                                        </ux-text-lines-limit>
                                    </div>
                                    <div class="ux-iws-teaser-story__cta">
                                        <a
                                            href="#"
                                            class="ux-button ux-button--icon-only"
                                            title="next"
                                            aria-label="next"
                                            role="button"
                                        >
                                            <ux-icon name="chevron-right" />
                                        </a>
                                    </div>
                                </div>
                            </ux-iws-link-wrapper>
                        </ux-slider-slide>
                        <ux-slider-slide>
                            <ux-iws-link-wrapper
                                class="ux-iws-teaser-story ux-iws-teaser-story--horizontal"
                            >
                                <div
                                    class="ux-iws-teaser-story__image-container"
                                >
                                    <img
                                        src="./mock-assets/images/mytrumpf/myt-homepage-slider-image-1.png"
                                        alt=""
                                    />
                                </div>
                                <div class="ux-iws-teaser-story__tag-container">
                                    <div
                                        class="ux-iws-teaser-story__tag ux-iws-teaser-story__tag--orange"
                                    >
                                        FEATURE
                                    </div>
                                </div>
                                <div class="ux-iws-teaser-story__content">
                                    <div class="ux-iws-teaser-story__info">
                                        <h4
                                            class="ux-text-headline--small ux-u-mx-zero"
                                        >
                                            Name of the event
                                        </h4>
                                        <span
                                            class="ux-text-tiny ux-text-tiny--bold ux-u-mx-zero"
                                        >
                                            29. Oktober bis 03. November 2022
                                        </span>
                                        <ux-text-lines-limit
                                            text-lines-l="5"
                                            text-lines-xl="5"
                                        >
                                            <p>Example with short text.</p>
                                        </ux-text-lines-limit>
                                    </div>
                                    <div class="ux-iws-teaser-story__cta">
                                        <a
                                            href="#"
                                            class="ux-button ux-button--icon-only"
                                            title="next"
                                            aria-label="next"
                                            role="button"
                                        >
                                            <ux-icon name="chevron-right" />
                                        </a>
                                    </div>
                                </div>
                            </ux-iws-link-wrapper>
                        </ux-slider-slide>
                        <ux-slider-slide>
                            <ux-iws-link-wrapper
                                class="ux-iws-teaser-story ux-iws-teaser-story--horizontal"
                            >
                                <div
                                    class="ux-iws-teaser-story__image-container"
                                >
                                    <img
                                        src="./mock-assets/images/mytrumpf/myt-homepage-slider-image-1.png"
                                        alt=""
                                    />
                                </div>
                                <div class="ux-iws-teaser-story__tag-container">
                                    <div
                                        class="ux-iws-teaser-story__tag ux-iws-teaser-story__tag--orange"
                                    >
                                        FEATURE
                                    </div>
                                </div>
                                <div class="ux-iws-teaser-story__content">
                                    <div class="ux-iws-teaser-story__info">
                                        <h4
                                            class="ux-text-headline--small ux-u-mx-zero"
                                        >
                                            Name of the event
                                        </h4>
                                        <span
                                            class="ux-text-tiny ux-text-tiny--bold ux-u-mx-zero"
                                        >
                                            29. Oktober bis 03. November 2022
                                        </span>
                                        <ux-text-lines-limit
                                            text-lines-l="5"
                                            text-lines-xl="5"
                                        >
                                            <p>${getDummyText(300)}</p>
                                        </ux-text-lines-limit>
                                    </div>
                                    <div class="ux-iws-teaser-story__cta">
                                        <a
                                            href="#"
                                            class="ux-button ux-button--icon-only"
                                            title="next"
                                            aria-label="next"
                                            role="button"
                                        >
                                            <ux-icon name="chevron-right" />
                                        </a>
                                    </div>
                                </div>
                            </ux-iws-link-wrapper>
                        </ux-slider-slide>
                        <ux-slider-pagination
                            slot="pagination"
                            bottom-pagination=""
                        >
                        </ux-slider-pagination>
                    </ux-slider>
                </div>
            </div>
        </div>
        <div class="ux-t-container ux-u-mt-fluid-l ux-u-mb-fluid-l">
            <div class="ux-row ux-u-mb-fluid-xs">
                <div class="ux-col-12">
                    <ux-w-service-calls
                        url="./mock-data/homepage/widget-service-calls.json"
                    ></ux-w-service-calls>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-xs">
                <div class="ux-col-12">
                    <ux-w-track
                        url="./mock-data/homepage/widget-track-empty.json"
                    ></ux-w-track>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-xs">
                <div class="ux-col-12">
                    <ux-data-ingest
                        data="./mock-data/homepage/widget-my-machines.json"
                    >
                        <ux-w-my-machines></ux-w-my-machines>
                    </ux-data-ingest>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-xs">
                <div class="ux-col-12">
                    <ux-data-ingest
                        data="./mock-data/homepage/widget-missions-empty.json"
                        translations="./mock-data/homepage/widget-missions-translations.json"
                    >
                        <ux-w-missions></ux-w-missions>
                    </ux-data-ingest>
                </div>
            </div>
        </div>
        <div class="ux-t-container">
            <div class="ux-row">
                <div class="ux-col-12">
                    <h2
                        class="ux-text-headline--big ux-u-text-align--center ux-u-m-zero"
                    >
                        Nützliche Links
                    </h2>
                </div>
            </div>
            <div class="ux-row">
                <div class="ux-col-12">
                    <ux-same-height>
                        <div class="ux-row ux-gutter-zero">
                            <div class="ux-col-12 ux-col-sm-6 ux-col-lg">
                                <ux-iws-teaser-icon
                                    icon-name="contact-list"
                                    shadow="false"
                                    variant="service-icon"
                                >
                                    <p
                                        slot="title"
                                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                                        data-same-height="title"
                                    >
                                        Kontakte
                                    </p>
                                    <div slot="link">
                                        <a
                                            href="#contacts"
                                            class="ux-text-link ux-text-link--green"
                                        >
                                            Mehr erfahren
                                            <ux-icon name="arrow-small-right" />
                                        </a>
                                    </div>
                                </ux-iws-teaser-icon>
                            </div>
                            <div class="ux-col-12 ux-col-sm-6 ux-col-lg">
                                <ux-iws-teaser-icon
                                    icon-name="arrow-download"
                                    shadow="false"
                                    variant="service-icon"
                                >
                                    <p
                                        slot="title"
                                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                                        data-same-height="title"
                                    >
                                        Kataloge
                                    </p>
                                    <div slot="link">
                                        <a
                                            href="#contacts"
                                            class="ux-text-link ux-text-link--green"
                                        >
                                            Mehr erfahren
                                            <ux-icon name="arrow-small-right" />
                                        </a>
                                    </div>
                                </ux-iws-teaser-icon>
                            </div>
                            <div class="ux-col-12 ux-col-sm-6 ux-col-lg">
                                <ux-iws-teaser-icon
                                    icon-name="circle-info"
                                    shadow="false"
                                    variant="service-icon"
                                >
                                    <p
                                        slot="title"
                                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                                        data-same-height="title"
                                    >
                                        FAQ
                                    </p>
                                    <div slot="link">
                                        <a
                                            href="#contacts"
                                            class="ux-text-link ux-text-link--green"
                                        >
                                            Mehr erfahren
                                            <ux-icon name="arrow-small-right" />
                                        </a>
                                    </div>
                                </ux-iws-teaser-icon>
                            </div>
                            <div class="ux-col-12 ux-col-sm-6 ux-col-lg">
                                <ux-iws-teaser-icon
                                    icon-name="machine-circle-arrows"
                                    shadow="false"
                                    variant="service-icon"
                                >
                                    <p
                                        slot="title"
                                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                                        data-same-height="title"
                                    >
                                        Gebrauchtmaschine des Monats
                                    </p>
                                    <div slot="link">
                                        <a
                                            href="#contacts"
                                            class="ux-text-link ux-text-link--green"
                                        >
                                            Mehr erfahren
                                            <ux-icon name="arrow-small-right" />
                                        </a>
                                    </div>
                                </ux-iws-teaser-icon>
                            </div>
                            <div class="ux-col-12 ux-col-sm-6 ux-col-lg">
                                <ux-iws-teaser-icon
                                    icon-name="application-bending"
                                    shadow="false"
                                    variant="service-icon"
                                >
                                    <p
                                        slot="title"
                                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                                        data-same-height="title"
                                    >
                                        Programmierdaten
                                    </p>
                                    <div slot="link">
                                        <a
                                            href="#contacts"
                                            class="ux-text-link ux-text-link--green"
                                        >
                                            Mehr erfahren
                                            <ux-icon name="arrow-small-right" />
                                        </a>
                                    </div>
                                </ux-iws-teaser-icon>
                            </div>
                        </div>
                    </ux-same-height>
                </div>
            </div>
        </div>
        ${args.guidedTour
            ? html`<ux-guided-tour
                  endpoint="./mock-data/guided-tour/guided-tour-homepage.json"
                  auto-start=${args.autoStart}
              ></ux-guided-tour>`
            : ""}
    `;
};

const RedesignedQuickLinksMobile = () => {
    return html`
        <div class="ux-iws-quicklinks">
            <a class="ux-iws-quicklink" href="#">
                <ux-icon name="machine" size-s="40"></ux-icon>
                <span
                    class="ux-iws-quicklink__text ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-ml-xxs"
                >
                    Meine Maschinen
                </span>
            </a>
            <a class="ux-iws-quicklink" href="#">
                <ux-icon name="newspaper" size-s="40"></ux-icon>
                <span
                    class="ux-iws-quicklink__text ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-ml-xxs"
                >
                    Meine Bestellungen
                </span>
            </a>
            <a class="ux-iws-quicklink" href="#">
                <ux-icon name="hand-list-arrow" size-s="40"></ux-icon>
                <span
                    class="ux-iws-quicklink__text ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-ml-xxs"
                >
                    Meine Servicefälle
                </span>
            </a>
            <a class="ux-iws-quicklink" href="#">
                <ux-icon name="software-cube" size-s="40"></ux-icon>
                <span
                    class="ux-iws-quicklink__text ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-ml-xxs"
                >
                    Meine Software
                </span>
            </a>
            <a class="ux-iws-quicklink" href="#">
                <ux-icon name="arrow-download" size-s="40"></ux-icon>
                <span
                    class="ux-iws-quicklink__text ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-ml-xxs"
                >
                    Downloads
                </span>
            </a>
            <a class="ux-iws-quicklink" href="#">
                <ux-icon name="whiteboard-avatar" size-s="40"></ux-icon>
                <span
                    class="ux-iws-quicklink__text ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-ml-xxs"
                >
                    Schulungen
                </span>
            </a>
        </div>
    `;
};

const originalPartsTile = () => {
    return html` <ux-iws-link-wrapper>
        <div class="ux-iws-teaser-tile" data-guided-tour="e-shop">
            <div class="ux-iws-teaser-tile__overlay"></div>
            <picture>
                <img
                    src="./mock-assets/images/mytrumpf/myt-homepage-tile-e-shop.png"
                    alt="E-Shop Originalteile"
                />
            </picture>
            <div class="ux-iws-teaser-tile__content">
                <h3
                    class="ux-iws-teaser-tile__title ux-text-headline ux-text-headline--small ux-u-text-bold"
                >
                    E-Shop Originalteile
                    <a href="#"></a>
                </h3>
            </div>
        </div>
    </ux-iws-link-wrapper>`;
};

const punchingToolsTile = () => {
    return html` <ux-iws-link-wrapper>
        <div class="ux-iws-teaser-tile ">
            <div class="ux-iws-teaser-tile__overlay"></div>
            <picture>
                <img
                    src="./mock-assets/images/mytrumpf/myt-homepage-tile-punchingtools.png"
                    alt="Stanzwerkzeuge"
                />
            </picture>
            <div class="ux-iws-teaser-tile__content">
                <h3
                    class="ux-iws-teaser-tile__title ux-text-headline ux-text-headline--small ux-u-text-bold"
                >
                    Stanzwerkzeuge
                </h3>
                <a href="#"></a>
            </div>
        </div>
    </ux-iws-link-wrapper>`;
};

const bendingToolsTile = () => {
    return html` <ux-iws-link-wrapper>
        <div class="ux-iws-teaser-tile">
            <div class="ux-iws-teaser-tile__overlay"></div>
            <picture>
                <img
                    src="./mock-assets/images/mytrumpf/myt-homepage-tile-bendingtools.png"
                    alt="Biegewerkzeuge"
                />
            </picture>
            <div class="ux-iws-teaser-tile__content">
                <h3
                    class="ux-iws-teaser-tile__title ux-text-headline ux-text-headline--small ux-u-text-bold"
                >
                    Biegewerkzeuge
                </h3>
                <a href="#"></a>
            </div>
        </div>
    </ux-iws-link-wrapper>`;
};

const explosionDrawingTile = (
    modifierHeight = "",
    modifierAlignment = "",
    shopsAvailable
) => {
    const imageSrc =
        shopsAvailable === 1 || shopsAvailable === 2
            ? "./mock-assets/images/mytrumpf/myt-homepage-tile-explosiondrawings-mobile.jpg"
            : "./mock-assets/images/mytrumpf/myt-homepage-tile-explosiondrawings.jpg";

    return html` <ux-iws-link-wrapper>
        <div class="ux-iws-teaser-tile ${modifierHeight} ${modifierAlignment}">
            <div class="ux-iws-teaser-tile__overlay"></div>
            <picture>
                <source media="(min-width:768px)" srcset="${imageSrc}" />
                <img
                    src="./mock-assets/images/mytrumpf/myt-homepage-tile-explosiondrawings-mobile.jpg"
                    alt="Flowers"
                />
            </picture>
            <div class="ux-iws-teaser-tile__content">
                <h3
                    class="ux-iws-teaser-tile__title ux-text-headline ux-text-headline--small ux-u-text-bold"
                >
                    Explosionszeichnungen
                </h3>
                <p class="ux-iws-teaser-tile__text ux-text-normal">
                    von der Zeichnung zum Teil
                </p>
                <a href="#"></a>
            </div>
        </div>
    </ux-iws-link-wrapper>`;
};

export const Default = (args) =>
    renderPageTemplate(() => TemplateRedesign(args));
